import { Calendar } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  REPORT_DATE_RANGE_OPTIONS,
  ReportDateRangeOption,
} from '@/hooks/useReportDateRange';
import { dateRangeLabelKey } from '@/utils/dateRangeI18n';

interface ReportDateRangeFilterProps {
  dateRange: ReportDateRangeOption;
  onDateRangeChange: (value: ReportDateRangeOption) => void;
  customFrom: string;
  customTo: string;
  onCustomFromChange: (value: string) => void;
  onCustomToChange: (value: string) => void;
  className?: string;
}

export default function ReportDateRangeFilter({
  dateRange,
  onDateRangeChange,
  customFrom,
  customTo,
  onCustomFromChange,
  onCustomToChange,
  className = '',
}: ReportDateRangeFilterProps) {
  const { t } = useTranslation();

  return (
    <div className={`flex flex-wrap gap-4 items-end ${className}`}>
      <div className="space-y-1.5 flex-1 min-w-[200px]">
        <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
          <Calendar className="w-4 h-4 text-gray-400" />
          {t('dates.duration')}
        </label>
        <select
          className="input-field"
          value={dateRange}
          onChange={(e) => onDateRangeChange(e.target.value as ReportDateRangeOption)}
        >
          {REPORT_DATE_RANGE_OPTIONS.map((opt) => (
            <option key={opt} value={opt}>
              {t(dateRangeLabelKey(opt))}
            </option>
          ))}
        </select>
      </div>

      {dateRange === 'Custom Date' && (
        <>
          <div className="space-y-1.5 flex-1 min-w-[150px]">
            <label className="text-sm font-medium text-gray-700">{t('dates.fromDate')}</label>
            <input
              type="date"
              className="input-field"
              value={customFrom}
              onChange={(e) => onCustomFromChange(e.target.value)}
            />
          </div>
          <div className="space-y-1.5 flex-1 min-w-[150px]">
            <label className="text-sm font-medium text-gray-700">{t('dates.toDate')}</label>
            <input
              type="date"
              className="input-field"
              value={customTo}
              onChange={(e) => onCustomToChange(e.target.value)}
            />
          </div>
        </>
      )}
    </div>
  );
}
